import plusIcon from "./icons8-plus-50.png";
import menuIcon from "./icons8-menu-64.png";
import dropIconSmall from "./icons8-drop-down-50.png";
import ideaIcon from "./icons8-idea-64.png";
import sendIcon from "./icons8-send-48.png";
import messageIcon from "./icons8-message-48.png";
import expandIcon from "./icons8-expand-arrow-64.png";
import threeDotIcon from "./icons8-menu-vertical-30.png";
import helpIcon from "./icons8-help-50.png";
import activityIcon from "./icons8-activity-48.png";
import settingsIcon from "./icons8-settings-64.png";
import dotIcon from "./icons8-dot-30.png";
import upArrowIcon from "./icons8-collapse-arrow-64.png";
import wallIcon from "./icons8-wall-64.png";
import moonIcon from "./icons8-moon-64.png";
import linkIcon from "./icons8-link-64.png";
import okIcon from "./icons8-ok-64.png";
import copyIcon from "./icons8-copy-48.png";
import crossIcon from "./icons8-cross-50.png";
import signOutIcon from "./icons8-sign-out-50.png";
import navigateIcon from "./icons8-circumnavigation-64.png";
import codeIcon from "./icons8-code-50.png";
import writeIcon from "./icons8-memo-64.png";

export const darkIcon = {
  plusIcon,
  menuIcon,
  dropIconSmall,
  ideaIcon,
  sendIcon,
  messageIcon,
  threeDotIcon,
  expandIcon,
  helpIcon,
  activityIcon,
  settingsIcon,
  dotIcon,
  upArrowIcon,
  wallIcon,
  moonIcon,
  linkIcon,
  okIcon,
  copyIcon,
  crossIcon,
  signOutIcon,
  navigateIcon,
  codeIcon,
  writeIcon,
};
